import React from 'react';
import {
  AiFillCheckCircle,
  AiFillCloseCircle,
  AiFillEnvironment,
  AiFillInfoCircle,
} from 'react-icons/ai';

import { useRecoilState } from 'recoil';
import { toastState } from 'recoils/common/commonState';
import styled, { keyframes } from 'styled-components';

import { getVariantToastStyle } from 'styles/components/getVariantStyle';

/**
 * @desc Toast 컴포넌트
 */
const Toast = () => {
  const [toast, setToast] = useRecoilState(toastState);
  const { visible, severity, detail } = toast;

  // 3초 후 자동으로 닫힘
  React.useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        setToast((prev) => ({ ...prev, visible: false }));
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [visible, setToast]);

  // 심각도에 따른 아이콘 반환 함수
  const SeviertyIcon = (severity) => {
    switch (severity) {
      case 'info':
        return <AiFillInfoCircle />;
      case 'success':
        return <AiFillCheckCircle />;
      case 'error':
        return <AiFillCloseCircle />;
      default:
        return <AiFillEnvironment />;
    }
  };

  return (
    <ToastContainer visible={visible.toString()} severity={severity}>
      <ToastWrapper>
        <ToastIconArea>{SeviertyIcon(severity)}</ToastIconArea>
        <ToastTextArea>
          <span>{detail}</span>
        </ToastTextArea>
      </ToastWrapper>
    </ToastContainer>
  );
};

export default Toast;

// 슬라이드 인 애니메이션
const slideIn = keyframes`
  from {
    transform: translateX(100%);
     opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

// 슬라이드 아웃 애니메이션
const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 0.5;
  }
  to {
    transform: translateX(100%);
   opacity: 0;
  }
`;

const ToastContainer = styled.div`
  position: fixed;
  top: 65px;
  right: ${({ visible }) => (visible === 'true' ? '20px' : '-100%')};

  padding: 10px 40px 10px 10px;
  border-radius: 4px;
  animation: ${({ visible }) => (visible === 'true' ? slideIn : slideOut)} 0.9s
    ease-in-out;
  opacity: ${({ visible }) => (visible === 'true' ? '1' : '0')};
  display: ${({ visible }) => (visible === 'true' ? 'block' : 'none')};
  transition:
    opacity 0.9s ease-in-out,
    right 0.5s ease-in-out;
  z-index: 99999;
  border-left: 5px solid ${({ severity }) => getVariantToastStyle(severity)};

  svg {
    fill: ${({ severity }) => getVariantToastStyle(severity)};
  }

  background: ${({ theme }) => theme.color.white};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  color: ${({ theme }) => theme.color.gray900};
`;

const ToastWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ToastIconArea = styled.div`
  padding-right: 15px;
  font-size: 25px;
  display: flex;
  justify-content: center;
`;

const ToastTextArea = styled.div`
  min-width: 200px;
  h3 {
    font-size: 15px;
  }
  span {
    font-size: 13px;
  }
`;
